class VideoLightbox {
  constructor() {

    // define variables
    const playButtons = document.querySelectorAll('.video-lightbox__play-button');
    const modalCloseButtons = document.querySelectorAll('.modal__close');

    const stopVideos = () => {
      const videos = document.querySelectorAll( 'video.modal__video' );
      const iframes = document.querySelectorAll('iframe.modal__video');
      if(videos) {
        videos.forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });

      if(iframes) {
        iframes.forEach((iframe) => {
          const iframeSrc = iframe.src;
          iframe.src = '';
          iframe.src = iframeSrc;
        });
      }
      }
    }

    // For each video lightbox button
    playButtons.forEach(element => {
      // grab the lightbox for the play button
      const lightbox = element.parentElement.nextElementSibling;

      // show modal when play button is clicked
      element.addEventListener('click', () => {
        lightbox.classList.add('is-active');
        lightbox.classList.remove('is-inactive');
      })
    }); 

    // For each modal close button
    modalCloseButtons.forEach(element => {
      // grab the lightbox for the modal button
      const lightbox = element.parentElement.parentElement;

      // dismiss lightbox when close button is clicked
      element.addEventListener('click', () => {
        lightbox.classList.add('is-inactive');
        lightbox.classList.remove('is-active');

        // pause all videos
        stopVideos();
      })
    }); 
  }
}

export default VideoLightbox;